<template>
   <div>
    <div class="c"></div>
    <div id="bd">
        <div id="banner">
        <div class="flexslider" >
            <ul class="slides">
                <li v-for='item in banners'>
                    <img :src="item.pictureurl" height="300px" >
                    <div class="ban-bg"></div>
                </li>
                <!-- <li>
                    <img src="../assets/Images/14415956107965.jpg" height="300px" >
                    <div class="ban-bg"></div>
                </li> -->
            </ul>
        </div>
        </div>
        <!-- end #banner -->
        <div class="wp">
            <div class="tit-i">
                <h3>行业动态</h3>
                <h5>INDUSTRY <span>NEWS</span></h5>
            </div>
            <ul class="ul-list">
                <li v-for="(item,index) in newsList">
                    <router-link :to="{path:'news_detail',name:'news_detail',query:{id:item.id}}">
                    <div class="pad">
                        <div class="bor">
                            <div class="txt">
                                <div class="newsdate">
                                    <span><em>{{item.createtime.split(' ')[0].split('-')[1]}}/{{item.createtime.split(' ')[0].split('-')[2]}}</em>{{item.createtime.split(' ')[0].split('-')[0]}}</span>
                                </div>
                                <div class="news-conwarp">
                                    <div class="title"> 
                                        <div class="news-title">
                                            <a href="javascript:;" >
                                                {{item.title}}
                                            </a>
                                            <div v-if="item.stick == 1" class="top">置顶</div>
                                        </div>
                                    </div>
                                    <a href="javascript:;" style="color:#666;">
                                        <p class="news-content">
                                            {{item.synopsis}}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    </router-link>
                </li>
            </ul>
            <div class="c"></div>
            <div class="pagess">
                <ul >
                    <li v-if='pageNum > 1' v-on:click="subChange(1)">首页</li>
                    <li v-if='pageNum > 1' v-on:click="pageNum--,subChange(pageNum-1)"><a >上一页</a></li>
                    <li v-for="(item,index) in pages" :class="{'thisclass':index==(pageNum-1)}" v-on:click="subChange(index+1)"> <a >{{index+1}}</a></li>
                    <li v-if="pageNum < pages" v-on:click="pageNum++,subChange(pageNum+1)"><a >下一页</a></li>
                    <li v-if="pageNum < pages" v-on:click="subChange(pages)">末页</li>
                </ul>
            </div>
        </div>
    </div>
    <!-- end #bd -->
</div>
</template>
<style>
/* .bannerImg {
  background-image: url(../assets/Images/14415956107965.jpg);
} */
#banner .flexslider .slides img {
    max-width: 100%;
    width: auto;
    display: inline-block;
    vertical-align: middle;
}
</style>
<script>
import {flexslider} from '../assets/Scripts/banner.js'
import { getNewsList,getBanner } from '../assets/Scripts/fn.js' 
var self;
export default {
    data(){
        return{
            flag:0,
            banners:[],
            newsType:[],//新闻类型
            newsList:[],//新闻列表
            pages:1,//页数
            pageNum:1,//当前页

        }
    },
    mounted(){
        //flexslider()
        this.subChange(1)
    },
    methods:{
        btnClick(pageNum){
            this.pageNum = pageNum
            this.subChange()   
        },
        subChange(pageNum){
            this.pageNum = pageNum
            //console.log(pageNum)
            this.$get("/api/website/xzsoft/website/xwdt/getNewsList",{pageNum:pageNum}).then((response) => {
            //console.log("=====新闻类型")
            //console.log(response.data)
            this.pageNum = response.data.pageNum;
            this.newsList = response.data.list;
            this.pages = response.data.pages;
            //console.log(this.pageNum)
        }).catch(function(error) {
            console.log(error,)
        })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/xwdt.vue